// Author YuJiaBei
// Date 2022-01-26 16:47:52

class EmOpcComputedEoc {
constructor({
        id = null,
        parentId = '',
        parentName = '',
        seq = '',
        eocIdEoct = '',
        eocHistoric = '',
        eoctName = '',
        eocNodeId = '',
        eocStatusNodeId = '',
        name = '',
        eocValueType = '',
        eocDefaultValue = '',
        eocEowUniType = '',
        eocEnable = '',
        eocExAttrA = '',
        eocExAttrB = '',
        eocExAttrC = '',
        eocExAttrD = '',
        eocExAttrE = '',
        eocStatusWarnGte = '',
        eocStatusWarnLt = '',
        eocStatusErrorGte = '',
        eocStatusErrorLt = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.parentName = parentName;
    this.seq = seq;
    this.eocIdEoct = eocIdEoct;
    this.eocHistoric = eocHistoric;
    this.eoctName = eoctName;
    this.eocNodeId = eocNodeId;
    this.eocStatusNodeId = eocStatusNodeId;
    this.name = name;
    this.eocValueType = eocValueType;
    this.eocDefaultValue = eocDefaultValue;
    this.eocEowUniType = eocEowUniType;
    this.eocEnable = eocEnable;
    this.eocExAttrA = eocExAttrA;
    this.eocExAttrB = eocExAttrB;
    this.eocExAttrC = eocExAttrC;
    this.eocExAttrD = eocExAttrD;
    this.eocExAttrE = eocExAttrE;
    this.eocStatusWarnGte = eocStatusWarnGte;
    this.eocStatusWarnLt = eocStatusWarnLt;
    this.eocStatusErrorGte = eocStatusErrorGte;
    this.eocStatusErrorLt = eocStatusErrorLt;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcComputedEoc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.id',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentName',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.parentName',
        sortable: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'seq',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocHistoric',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocHistoric',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eoctName',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eoctName',
        sortable: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedTypeEoct'
        }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocNodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocStatusNodeId',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocStatusNodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocValueType',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocValueType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: 'String' },
                            { value: '2', text: 'Int' },
                            { value: '3', text: 'Float' },
                            { value: '4', text: 'Boolean' }
            ]
        }
        },
        {
        key: 'eocDefaultValue',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocDefaultValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocEowUniType',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocEowUniType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: ' AND ' },
                            { value: '2', text: ' OR ' }
            ]
        }
        },

        {
        key: 'eocEnable',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocEnable',
        sortable: true,
            form: {
            type: 'boolean'
            }
        },
        {
            key: 'eocStatusErrorLt',
            label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocStatusErrorLt',
            sortable: true,
            form: {
                type: 'inputNumber'
            }
        },
        {
        key: 'eocStatusWarnLt',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocStatusWarnLt',
        sortable: true,
            form: {
            type: 'inputNumber'
            }
        },
        {
            key: 'eocStatusWarnGte',
            label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocStatusWarnGte',
            sortable: true,
            form: {
                type: 'inputNumber'
            }
        },
        {
        key: 'eocStatusErrorGte',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.eocStatusErrorGte',
        sortable: true,
            form: {
            type: 'inputNumber'
            }
        },

        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcComputedEoc.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    parentIdFilter : '',
    parentNameFilter : '',
    eocHistoricGteFilter : '',
    seqFilter : '',
    eocIdEoctFilter : '',
    eoctNameFilter : '',
    eocNodeIdFilter : '',
    eocStatusNodeIdFilter : '',
    nameFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    eocValueTypeFilter : '',
    eocDefaultValueFilter : '',
    eocEowUniTypeFilter : '',
    eocEnableFilter : '',
    eocExAttrAFilter : '',
    eocExAttrBFilter : '',
    eocExAttrCFilter : '',
    eocExAttrDFilter : '',
    eocExAttrEFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentNameFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.parentName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
        {
        key: 'eocHistoricGteFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.eocHistoricGte',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eoctNameFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.eoctName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedTypeEoct'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"eocIdEoct":"id"}'
                }
        },
        {
        key: 'eocNodeIdFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.eocNodeId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocStatusNodeIdFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.eocStatusNodeId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocValueTypeFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.eocValueType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: 'String' },
                { value: '2', text: 'Int' },
                { value: '3', text: 'Float' },
                { value: '4', text: 'Boolean' }
            ]
        }
        },
        {
        key: 'eocDefaultValueFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.eocDefaultValue',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocEowUniTypeFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.eocEowUniType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: ' AND ' },
                { value: '2', text: ' OR ' }
            ]
        }
        },
        {
        key: 'eocEnableFilter',
        label: 'label.em.base.opcClient.emOpcComputedEoc.filter.eocEnable',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
];


    const entityFormConfigs = [
        {
            key: 'id',
            label: 'label.em.base.opcClient.emOpcComputedEoc.entity.id',
            sortable: true,
            disabled: true,
            form: {
                type: 'inputNumber'
            }
        },
        {
        key: 'parentName',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.parentName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
        {
        key: 'seq',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eocHistoric',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocHistoric',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eoctName',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eoctName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedTypeEoct'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"eocIdEoct":"id"}'
                }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocNodeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'eocStatusNodeId',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocStatusNodeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'eocValueType',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocValueType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: 'String' },
                { value: '2', text: 'Int' },
                { value: '3', text: 'Float' },
                { value: '4', text: 'Boolean' }
            ]
        }
        },
        {
        key: 'eocDefaultValue',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocDefaultValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocEowUniType',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocEowUniType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: ' AND ' },
                { value: '2', text: ' OR ' }
            ]
        }
        },
        {
        key: 'eocEnable',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocEnable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'eocExAttrA',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocExAttrA',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },

        {
            key: 'eocStatusErrorLt',
            label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocStatusErrorLt',
            sortable: true,
            disabled: false,
            form: {
                type: 'inputNumber'
            }
        },
        {
        key: 'eocStatusWarnLt',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocStatusWarnLt',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
            key: 'eocStatusWarnGte',
            label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocStatusWarnGte',
            sortable: true,
            disabled: false,
            form: {
                type: 'inputNumber'
            }
        },
        {
        key: 'eocStatusErrorGte',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.eocStatusErrorGte',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },

        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcComputedEoc.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmOpcComputedEoc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
